export const CANVAS_ITEM_MARGIN = 16;
export const CANVAS_PADDING_VERTICAL = 16;
export const CANVAS_PADDING_HORIZONTAL = 24;
// Reference canvas height used when rendering headlessly (the scheduled-report
// PDF renderer). Row height is normally derived from the live viewport so the
// canvas fits the screen — but the renderer grows the viewport tall to capture
// the whole report, which would stretch every gadget. Sizing rows against a
// fixed "standard screen" height instead keeps gadgets at their natural
// proportions regardless of the capture viewport.
export const HEADLESS_RENDER_CANVAS_HEIGHT = 1080;
export const POPUP_REPORT_HEIGHT = {
  MODAL_HEIGHT: '90vh',
  CANVAS_SIZE_MULTIPLIER: 0.9,
};

// Reference "device" dimensions a canvas is pinned to when rendered as a
// scaled preview (see ScaledCanvasFrame / CanvasPreview). Rendering at a fixed
// desktop size means react-grid-layout never reflows to the real container and
// mobile layout never triggers — the whole block is then transform-scaled down
// to fit wherever it is placed.
export const PREVIEW_DEVICE_WIDTH = 1920;
export const PREVIEW_DEVICE_HEIGHT = 1080;
